/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { Switch, Route } from 'react-router-dom';

import ProtectedRoute from './components/ProtectedRoute';
import MyAccount from './components/MyAccount';
// import AccountLogin from './components/AccountLogin';

const Routes = () => (
    <>
        <Switch>
            <Route
                path="/account/gift-list/:id?"
                exact
                component={() => (
                    <MyAccount
                        page={{
                            account: true,
                        }}
                        module="GiftList"
                    />
                )}
            />
            {/* H&D */}
            <Route
                path="/gifthistory-home-gift-baskets/:params?"
                component={() => <MyAccount page={{ account: true }} module="GiftList" />}
            />
            {/* CCO */}
            <Route
                path="/gifthistory-home-cookies/:params?"
                component={() => <MyAccount page={{ account: true }} module="GiftList" />}
            />
            {/* STY */}
            <Route
                path="/gifthistory-home-steaks/:params?"
                component={() => <MyAccount page={{ account: true }} module="GiftList" />}
            />
            {/* WLF */}
            <Route
                path="/gifthistory-home-bakery/:params?"
                component={() => <MyAccount page={{ account: true }} module="GiftList" />}
            />
            <Route
                path="/account/orders/:uuid/:order/:zipcode?/:billingzipcode?"
                exact
                component={() => <MyAccount page={{ account: true }} module="OrderDetails" />}
            />
            <Route
                path="/account/orders"
                exact
                component={() => <MyAccount page={{ account: true }} module="TrackOrder" />}
            />
            <ProtectedRoute
                path="/account/subscriptions"
                component={() => <MyAccount page={{ account: true }} module="Subscriptions" />}
            />
            <ProtectedRoute
                path="/account/address-book"
                component={() => <MyAccount page={{ account: true }} module="AddressBook" />}
            />
            <ProtectedRoute
                path="/account/billing-address"
                component={() => <MyAccount page={{ account: true }} module="BillingAddress" />}
            />
            <ProtectedRoute
                path="/account/profile"
                component={() => <MyAccount page={{ account: true }} module="ProfileAndPassword" />}
            />
            <ProtectedRoute
                path="/account/change-password"
                component={() => <MyAccount page={{ account: true }} module="ChangePassword" />}
            />
            <ProtectedRoute
                path="/account/change-email"
                component={() => <MyAccount page={{ account: true }} module="ChangeEmail" />}
            />
            <ProtectedRoute
                path="/account/email-preference"
                component={() => <MyAccount page={{ account: true }} module="EmailPreference" />}
            />
            <ProtectedRoute
                path="/account/passport"
                component={() => <MyAccount page={{ account: true }} module="Passport" />}
            />
            {/* <ProtectedRoute
                path="/account/login"
                component={() => <AccountLogin module="LoginForm" />}
            />
            <ProtectedRoute
                path="/account/reset-password"
                component={() => <AccountLogin module="ResetPasswordForm" />}
            />
            <ProtectedRoute
                path="/account/create-account"
                component={() => <AccountLogin module="CreateAccountForm" />}
            /> */}
            <ProtectedRoute
                path="/account"
                component={() => <MyAccount page={{ account: true }} module="AccountHome" />}
            />
        </Switch>
    </>
);

export default Routes;
